import service from "@/axios/service/service";
export default {
  methods: {
    async handeleCoverImage(callBackFun) {
      //如果没有上传封面图片，则直接处理正文图片信息
      if (!this.form.imgs) {
        //转换正文中所有的图片
        this.urlToIdAll(callBackFun);
      } else {
        await service
          .urlToId(
            { imgs: this.form.imgs, imgsCut: this.form.imgsCut },
            "imags/getImageId"
          )
          .then(json => {
            if (json.respCode === 100) {
              this.form.imgs = json.data.imgId;
              this.form.imgsCut = json.data.imgCutId;
              //转换正文中所有的图片
              this.urlToIdAll(callBackFun);
            } else {
              // this.$message.error("图片url转id失败!")
            }
          });
      }
    },
    //用于遍历本篇游记的所有图片,并进行url到id的转换
    async urlToIdAll(callBackFun) {
      let _this = this;
      for (let i = 0; i < _this.form.nodeList.length; i++) {
        if (_this.form.nodeList[i].paragraphList) {
          for (
            let j = 0;
            j < _this.form.nodeList[i].paragraphList.length;
            j++
          ) {
            if (_this.form.nodeList[i].paragraphList[j].bodyList) {
              for (
                let z = 0;
                z < _this.form.nodeList[i].paragraphList[j].bodyList.length;
                z++
              ) {
                await _this.urlToId(i, j, z);
              }
            }
          }
        }
      }
      callBackFun();
    },
    //urlToId方法用于将正文中的图片也转换成为id并且保存到content字段
    urlToId(i, j, z) {
      let _this = this;
      return new Promise((resolve, reject) => {
        //1、图片 2、视频 3、音频 都需要把url转id
        if (
          _this.form.nodeList[i].paragraphList[j].bodyList[z].type &&
          [1, 2, 3].includes(
            _this.form.nodeList[i].paragraphList[j].bodyList[z].type
          )
        ) {
          service
            .urlToId(
              {
                imgs:
                  _this.form.nodeList[i].paragraphList[j].bodyList[z].content
              },
              "imags/getImageId"
            )
            .then(json => {
              if (json.respCode === 100) {
                _this.form.nodeList[i].paragraphList[j].bodyList[z].content =
                  json.data.imgId;
              } else {
                // _this.$message.error("图片url转id失败!");
              }
              resolve();
            });
        } else {
          resolve();
        }
      });
    }
  }
};
